(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sleek-menu-drawer"] && !Shopify.designMode) return;
  try {
    const ANIM_DURATION = 300;
  const ANIM_EASING = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';

  class SleekMenuDrawer extends HTMLElement {
    connectedCallback() {
      const isCascade = this.classList.contains('sleek-menu-drawer--cascade');
      this.querySelectorAll('.sleek-menu-drawer__details > summary').forEach((summary) => {
        const details = summary.closest('details');
        const submenu = details?.querySelector(':scope > .menu-drawer__submenu');
        if (details?.classList.contains('menu-closing')) {
          this.#finishClosingDisclosure(details, summary, submenu);
        }
        const isOpen = details?.open && !details.classList.contains('menu-closing');
        details?.classList.toggle('menu-open', Boolean(isOpen));
        summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (isCascade) {
          summary.addEventListener('click', this.#onSummaryClick);
        }
      });
      this.querySelectorAll('.sleek-menu-drawer__mega-l2 > summary').forEach((summary) => {
        const details = summary.closest('details');
        const content = details?.querySelector(':scope > .sleek-menu-drawer__mega-l2-content');
        if (details?.classList.contains('menu-closing')) {
          this.#finishClosingDisclosure(details, summary, content);
        }
        const isOpen = details?.open && !details.classList.contains('menu-closing');
        summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        summary.addEventListener('click', this.#onMegaL2Click);
      });
    }

    #finishClosingDisclosure(details, summary, content) {
      content?.getAnimations().forEach((animation) => animation.cancel());
      content?.style.removeProperty('height');
      details.open = false;
      details.classList.remove('menu-open', 'menu-closing');
      summary.setAttribute('aria-expanded', 'false');
    }

    disconnectedCallback() {
      this.querySelectorAll('.sleek-menu-drawer__details > summary').forEach((summary) => {
        summary.removeEventListener('click', this.#onSummaryClick);
      });
      this.querySelectorAll('.sleek-menu-drawer__mega-l2 > summary').forEach((summary) => {
        summary.removeEventListener('click', this.#onMegaL2Click);
      });
    }

    #onSummaryClick = (event) => {
      event.preventDefault();
      const summary = event.currentTarget;
      this.#toggleSummary(summary);
    };

    #toggleSummary(summary) {
      const details = summary.closest('details');
      const submenu = details?.querySelector(':scope > .menu-drawer__submenu');
      if (!submenu) return;

      this.#animateHeight(
        submenu,
        details.open && !details.classList.contains('menu-closing'),
        () => {
          details.classList.remove('menu-closing');
          details.open = true;
          details.classList.add('menu-open');
          summary.setAttribute('aria-expanded', 'true');
        },
        () => {
          details.classList.remove('menu-open');
          details.classList.add('menu-closing');
          summary.setAttribute('aria-expanded', 'false');
        },
        () => {
          details.open = false;
          details.classList.remove('menu-open');
          details.classList.remove('menu-closing');
          summary.setAttribute('aria-expanded', 'false');
        }
      );
    }

    #onMegaL2Click = (event) => {
      event.preventDefault();
      this.#toggleMegaL2(event.currentTarget);
    };

    #toggleMegaL2(summary) {
      const details = summary.closest('.sleek-menu-drawer__mega-l2');
      const content = details?.querySelector(':scope > .sleek-menu-drawer__mega-l2-content');
      if (!content) return;
      this.#animateHeight(
        content,
        details.open && !details.classList.contains('menu-closing'),
        () => {
          details.classList.remove('menu-closing');
          details.open = true;
          summary.setAttribute('aria-expanded', 'true');
        },
        () => {
          details.classList.add('menu-closing');
          summary.setAttribute('aria-expanded', 'false');
        },
        () => {
          details.open = false;
          details.classList.remove('menu-closing');
          summary.setAttribute('aria-expanded', 'false');
        }
      );
    }

    #animateHeight(el, isOpen, openFn, closeStartFn, closeFinishFn) {
      const startHeight = el.getBoundingClientRect().height;
      el.getAnimations().forEach((a) => a.cancel());
      el.style.height = startHeight + 'px';

      if (isOpen) {
        closeStartFn();
        el.animate([{ height: startHeight + 'px' }, { height: '0px' }], {
          duration: ANIM_DURATION, easing: ANIM_EASING,
        }).onfinish = () => {
          el.style.height = '0px';
          closeFinishFn();
        };
      } else {
        openFn();
        const endHeight = el.scrollHeight;
        el.animate([{ height: startHeight + 'px' }, { height: endHeight + 'px' }], {
          duration: ANIM_DURATION, easing: ANIM_EASING,
        }).onfinish = () => { el.style.height = 'auto'; };
      }
    }
  }

  if (!customElements.get('sleek-menu-drawer')) {
    customElements.define('sleek-menu-drawer', SleekMenuDrawer);
  }
  } catch(e) { console.error(e); }
})();

})();
